$(document).ready(function() {

  $(".product-thumbnails").each(function() {
    if ($(this).find("img").length > 0){
      $(this).find("img").not(".gray-out").first().addClass("active");
    }
  });
  
  var thumbnails = $('.product-thumbnails img');  
  thumbnails.on('click keypress', function(event) {
    if (allyClick(event) === true)
    {
      var thumbnail = $(this);
      var thumbnailTitle = $(thumbnail).data('title');
      var mainImg = $('img.product-list-item-image[alt="'+thumbnailTitle+'"]');
      if (mainImg.attr('src') != thumbnail.attr('data-main-imgsrc')) {
        mainImg.attr('src',thumbnail.attr('data-img'));
        thumbnail.closest(".product-thumbnails").find(".active").removeClass("active");
        thumbnail.addClass("active");
      }
    }
  });
});